export const emailMessageAttachmentGridItemFrag = `
    id
    idFromMicrosoftGraph
    messageId
    name
    type
    size
    path
    lastModifiedDateTime
    isInline
    contentId
    contentLocation
`;
